import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { ErrorRoutingModule } from "./error-routing.module"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { ErrorComponent } from "./error.component"

@NgModule({
    declarations: [ErrorComponent],
    imports: [CommonModule, ErrorRoutingModule, SharedComponentsModule],
    exports: [ErrorComponent],
})
export class ErrorModule {}
